
import Profiles from './Profiles/Profiles';
import Payments from './Payments/Payments';
import Requests from './Requests/Requests';

class Admin {
    constructor(settings) {
        this.settings = settings;

        this.profiles = new Profiles(this.settings);
        this.payments = new Payments(this.settings);
        this.requests = new Requests(this.settings);
    }
}

export default Admin;
